export default "__VITE_ASSET__BrMKddze__"